<script>
import Layout from "../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Index Component
 */
export default {
  page: {
    title: "Index",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Index",
      items: [
        {
          text: "Index",
          active: true
        }
      ]
    };
  },
  mounted() {
    this.$router.replace({path: '/dashboard', query: {...this.$route.query}, append: true})
    // this.$router.replace({path: '/dashboard', query: {...this.$route.query}, append: true})
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

  </Layout>
</template>
